import { DateUtils, List, ModalUtils, ModelBase, NeoModel } from '@singularsystems/neo-core';
import { Nullable } from '@singularsystems/neo-core/dist/Model/Decorators';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../../../App/Models/NotificationDuration';
import { AppService, DomainTypes, Types } from '../../../DomainTypes';
import Holiday from '../../../Models/Catalogue/General/Holiday';

@NeoModel
export default class HolidayVM extends Views.ViewModelBase {
    
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        protected generalApiClient = AppService.get(Types.Domain.ApiClients.CatalogueGeneral),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private dataCache = AppService.get(DomainTypes.Services.DataCache)) {

        super(taskRunner);
    }

    public holidayList = new List(Holiday);
    public selectedYear = DateUtils.today();

    public async initialise() {
        await this.load();
    }

    public saveHolidays() {
        this.taskRunner.run(async () => {
            var response = await this.generalApiClient.saveHolidays(this.holidayList.toJSArray());
            this.holidayList.update(response.data);
            this.notifications.addSuccess("Save Successful", "Holidays saved successfully", NotificationDuration.Standard);
        });
    }

    public checkIsDirty() {
        if (this.holidayList.isDirty) {
            ModalUtils.showYesNoDismissible("Holidays not saved", "Are you sure you want to continue?", () => this.load());
        }else{
            this.load();
        }
    }

    public async load() {
        const response = await this.taskRunner.waitFor(this.generalApiClient.getHolidaysForYear(this.selectedYear.getFullYear()));
        this.holidayList.set(response.data);
    }
}